import React, { useEffect } from "react";
import HomeBanner from "../../components/new_redesign_components/sections/HomeBanner";
import CTASection from "../../components/new_redesign_components/sections/CTASection";
import HomeAccordion from "../../components/new_redesign_components/sections/HomeAccordion";
import Testimonials from "../../components/new_redesign_components/sections/Testimonials";
import homeContent from "../../components/new_redesign_components/content/Home.json";
import Col3Cards from "../../components/new_redesign_components/sections/Col3Cards";
import VerticalTabs from "../../components/new_redesign_components/sections/VerticalTabs";
import Onboarding from "../../components/new_redesign_components/sections/Onboarding";
import AwardSection from "../../components/new_redesign_components/sections/AwardSection";
import Seo from "../common/Seo";
import {
  ORGANIZATION_JSON_LD,
  PAGE_SEO,
  SOFTWARE_JSON_LD,
  WEBSITE_JSON_LD,
} from "../../constants/seo.mjs";
// import "../../bootstrap/dist/css/bootstrap.min.css";

const Home = () => {
  const {
    hero,
    cta1,
    cta2,
    cta3,
    accordion,
    testimonials,
    col3Cards,
    verticalTabs,
  } = homeContent;

  return (
    <>
      <Seo
        {...PAGE_SEO.home}
        jsonLd={[ORGANIZATION_JSON_LD, WEBSITE_JSON_LD, SOFTWARE_JSON_LD]}
      />
      <HomeBanner content={hero} />
      <Onboarding />
      <VerticalTabs content={verticalTabs} />
      <CTASection content={cta1} />
      <HomeAccordion content={accordion} />
      <CTASection content={cta2} />
      {/* <Col3Cards content={col3Cards} /> */}
      <Testimonials content={testimonials} />
      <AwardSection />
      <CTASection content={cta3} />
    </>
  );
};

export default Home;
